module.exports = "https://r.nearpod.com/assets/media/image/btn-bar-bg-2316428ab34e55fe0abcd17df173a2ca.png";